interface SubCategoryChipProps {
  id: string
  name: string
  onClick?: () => void
  active?: boolean
}

export default function SubCategoryCard({ id, name, onClick, active }: SubCategoryChipProps) {
  return (
   

    <button
          key={id}
              onClick={onClick}
              className={`
                px-6 py-2  border rounded-lg hover:from-green-700 hover:to-emerald-700 text-sm whitespace-nowrap
        transition-all
                ${active 
                  ? "bg-green-50 border border-green-200" 
                  : "border-gray-200"
                }
                `}
            >
            {name}
        </button>
  )
}
